/**
 * StaffDisableReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffDisableReq
 */
export interface StaffDisableReq {
  /** 资源ID */
  id: string
  /** 禁用原因 */
  reason?: string
  /** 禁用时长（小时），0表示永久 */
  duration?: number
  /** 禁用截止时间，优先级高于duration */
  until?: string
}

/**
 * StaffDisableReq Schema
 */
export const StaffDisableReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '资源ID',
      format: 'string',
      type: 'string',
      label: '资源ID',
    },
    reason: {
      description: '禁用原因',
      format: 'string',
      type: 'string',
      label: '禁用原因',
    },
    duration: {
      description: '禁用时长（小时），0表示永久',
      format: 'int',
      type: 'integer',
      label: '禁用时长',
    },
    until: {
      description: '禁用截止时间，优先级高于duration',
      format: '*time.Time',
      type: 'string',
      label: '禁用截止时间',
    },
  },
  required: ['id'],
  type: 'object',
}
